<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<vxe-grid ref="checkerrortable" v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent" ></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			checkerrordata: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_model:false,
				modal_title: '核对结果',
				modal_width:1000,
				modal_height:800,
				list_footerField:[
					{field:'amount',toFixed:2},
					{field:'jindieamount',toFixed:2}
				]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions){
				gridOptions.toolbarConfig.buttons = [{
					name: '导出',
					status: 'success',
					code: 'export'
				}, {
					name: '定位',
					status: 'danger',
					code: 'positioning'
				}]
				gridOptions.columns = [{
						field: 'serialNo',
						title: '单据编码',
					},
					// {
					// 	field: 'b',
					// 	title: '户名'
					// },
					// {
					// 	field: 'c',
					// 	title: '账号',
					// },
					// {
					// 	field: 'c',
					// 	title: '时间',
					// },
					{
						field: 'amount',
						title: '收款金额',
					},
					{
						field: 'jindieamount',
						title: '星空金额',
					},
					// {
					// 	field: 'c',
					// 	title: '对方户名',
					// },
					// {
					// 	field: 'c',
					// 	title: '对方账号',
					// },
							
					{
						field: 'export_jindie_sucess',
						title: '金蝶',
						slots:{
							default: ({row}) => {
								if(row.export_jindie_sucess == 1){
									return <span style="color:#67C23A;">已同步</span> 	
								}else{
									return <span style="color:#F56C6C;">未同步</span> 		
								}
							}
						}
					},
					{
						field: 'export_jindie_type',
						title: '金蝶模块',
					},
					{
						field: 'res',
						title: '核对结果',
					},																							
					// {
					// 	title: '操作',
					// 	fixed: "right",
					// 	align: 'center',
					// 	width: 65,
					// 	slots: {
					// 		default: ({row}) => {
					// 			return [<el-button type = "text" size = "mini" onClick = {() => {this.ddcode(row)}}>凭证</el-button>]
					// 		}
					// 	}
					// }
				]
				gridOptions.formConfig = false
			},
			list() {
				return new Promise((resolve) => {
					let data = this.checkerrordata
					// let groupdata = this.$Lodash.groupBy(this.data, 'bankAcc')
					// for(let i in groupdata){
					// 	let obj = {}
					// 	obj.id = groupdata[i][0].id
					// 	obj.bankAcc = i
					// 	obj.accName = groupdata[i][0].accName
					// 	obj.needamount = this.$Lodash.sumBy(groupdata[i], item=>parseFloat(item.needamount))
					// 	obj.needamount = obj.needamount.toFixed(2)
					// 	data.push(obj)
					// }
					// console.log(data)
					resolve({
						list: data
					})
				})
			},
			positioning(){
				let data = this.$refs.checkerrortable.getTableData().fullData
				data = data.map((item)=>{
					return item.id
				})
				this.$emit('positioning',{data:data.join(',')})
				this.modal_cancel()
				//console.log(data)
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>